
















import {computed, defineComponent, PropType} from "@vue/composition-api";
import ProjectLayout from "@tool/Pages/App/Project/layout/ProjectLayout.vue";
import {CrumbPage, ProjectEntityInterface} from "@tool/tool.types";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import DateRangePicker from "@tool/Pages/App/Project/Reports/partials/DateRangePicker.vue";
import {DateRangeInterface, ProjectReportSingleFilterInterface} from "@tool/Pages/App/Project/Reports/reports.types";
import {useInertia} from "@tool/Helpers/useInertia";
import moment from "moment";


export default defineComponent({
    components: {
        DateRangePicker,
        ProjectLayout,
        ThemeBlock
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        dateRange: {
            type: Object as PropType<DateRangeInterface<string>>,
            required: true
        },
        filters: {
            type: Array as PropType<ProjectReportSingleFilterInterface<any>[]>,
            required: true,
        }
    },
    setup(props) {

        const extraBreadcrumbs: CrumbPage[] = [{
            name: 'Reports',
            href: route('app.project.reports.index', props.project.slug)
        }];

        const localDateRange = computed<DateRangeInterface<string>>({
            get() {
                return props.dateRange;
            },
            set(newValue: DateRangeInterface<string>) {
                const dateFormat = 'YYYY-MM-DD';
                useInertia().get(route(route().current(), route().params), {
                    date_from: moment(newValue.from).format(dateFormat),
                    date_to: moment(newValue.to).format(dateFormat),
                }, {preserveScroll: true});
            }
        });

        const hasFilter = (filter: string) => {
            return props.filters.findIndex(currentFilter => currentFilter.type === filter) > -1;
        }
        const tabItemsList: { name: string, routeName: string; show: boolean }[] = [
            {name: 'Overview', routeName: 'app.project.reports.index', show: true},
            {name: 'Short Urls', routeName: 'app.project.reports.shorturls.index', show: !hasFilter('shorturl')},
            {
                name: 'Campaigns',
                routeName: 'app.project.reports.campaigns.index',
                show: !hasFilter('utm_campaign') && !hasFilter('shorturl')
            },
            {
                name: 'Sources',
                routeName: 'app.project.reports.sources.index',
                show: !hasFilter('utm_source') && !hasFilter('shorturl')
            },
            {
                name: 'Mediums',
                routeName: 'app.project.reports.mediums.index',
                show: !hasFilter('utm_medium') && !hasFilter('shorturl')
            },
            {
                name: 'Terms',
                routeName: 'app.project.reports.terms.index',
                show: !hasFilter('utm_term') && !hasFilter('shorturl')
            },
            {
                name: 'Contents',
                routeName: 'app.project.reports.contents.index',
                show: !hasFilter('utm_content') && !hasFilter('shorturl')
            },
        ];

        const tabItems = tabItemsList.filter(item => item.show).map((item) => {
            return {
                name: item.name,
                href: route(item.routeName, route().params),
                classes: {
                    active: route().current(item.routeName)
                }
            }
        });

        const filterRemove = (filter: ProjectReportSingleFilterInterface<any>) => {
            const params: any = route().params;

            if (typeof params['filter_' + filter.type]) {
                delete (params['filter_' + filter.type]);
            }

            useInertia().get(route(route().current(), params), {}, {
                preserveScroll: true
            });
        }

        return {
            localDateRange,
            extraBreadcrumbs,
            tabItems,
            filterRemove,
            hasFilter,
        }
    }
})
